module.exports = __webpack_public_path__ + "static/media/usdt-bnb.40ec0321.svg";